<template>
	<div>
		<span v-for="(line, index) of lines">
			<br v-if="index > 0"/>
			{{line}}
		</span>
	</div>
</template>

<script>
	export default {
		props: {'text': String},
		computed: {
			lines: function() {
				return this.text ? this.text.split('\n') : [];
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/ui/widgets/user-text.vue